<!--
 * @Description: 我的值班 选择人员
 * @Author: PF
 * @Date: 2023-09-01 14:37:20
 * @LastEditors: PF
 * @LastEditTime: 2023-09-01 15:26:36
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="wp80 hp80" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">选择人员</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-main class="mb10 pl0 pr0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" fixed align="center" width="80" />
            <el-table-column label="值班人姓名" prop="zbryxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Left END -->
            <el-table-column label="值班类别" prop="zblbmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="值班内容名称" prop="zbnrmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="值班日期" prop="zbrq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="值班时间" align="center" show-overflow-tooltip>
              <template #default="scope">
                {{ scope.row.zbkssj }}
                <span v-if="scope.row.zbkssj && scope.row.zbjssj">至</span>
                {{ scope.row.zbjssj }}
              </template>
            </el-table-column>
            <el-table-column label="手机" prop="yddh" align="center" show-overflow-tooltip />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer-but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, loadList } from '@/api/common'
import pagination from '@/components/pagination.vue'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])
const paginationObj = ref()
const row = ref()
const currentRow = ref()

const savestudent = () => {
  emits('ReturnData', currentRow.value)
  closeWindow('openDanTiao', emits, false)
}

// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'zbrq', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/bangong/tiaobanjilu/tiaohuanren',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.data = res.data
      dataGrid.value.multipleSelection = []
    }
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      row.value = props.row
      dataGrid.value.parms.zbrwid = row.value.zbrwid
      dataGrid.value.parms.zbryid = row.value.zbryid
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>
